import { FLOW_FUNERAL_URL } from 'config'

import { FORMATTED_DIRECT_CREMATION_PRICE } from 'views/cremation/shared/constants'

const data = {
  title: 'The simple, personal way to say goodbye',
  subtitle: `A direct cremation is a cremation without a service at the crematorium. It gives you the freedom to say goodbye your way. Arrange a direct cremation with our award winning team, from ${FORMATTED_DIRECT_CREMATION_PRICE}.`,
  images: {
    imageLeft: 'illustrations/blob_with_urn',
    imageRight: 'illustrations/sunset',
    mobileImage: 'e_trim/illustrations/blob-urn-family-sunset',
  },
  ctaLinks: [
    {
      text: 'Get a quote now',
      to: FLOW_FUNERAL_URL,
      variant: 'primary',
    },
  ],
}

export default data
